<template>
  <div
    v-if="isTextEmpty(title)"
    class="text-sm text-center font-normal text-red-600 my-2">
    {{ t('blocksSettings.pairing.empty_text') }}
  </div>

  <div
    v-else
    ref="scrollBox"
    :style="`--scroll-color: ${color}`"
    class="bg-white w-full overflow-x-hidden custom-scroll"
    :class="{
      [`absolute p-1 pb-0 ${format.startsWith('image') ? 'bottom-0' : 'top-0'} min-h-[30%] max-h-[75px] has-image flex justify-center`]:
        format.includes('image'),
      'h-full flex items-center justify-center w-full my-2':
        !format.includes('image'),
      '-me-1': hasVerticalScroll,
      'overflow-hidden': !hasVerticalScroll,
    }">
    <div
      v-tooltip.top="
        countUnitsInHtml(title) > maxLength
          ? {
              value: parseTooltip(title, {
                fontSize: '12px',
                inverted: true,
              }),
              escape: false,
              class: `!z-[1300] ${!rtl ? 'text-left' : 'text-right'}`,
            }
          : null
      "
      class="pairing-title text-center h3 w-full flex items-center justify-center leading-[1.4] px-1"
      v-html="
        parseTooltip(title, {
          fontSize: '14px',
          maxChars: maxLength,
          includeKatex: false,
        })
      "></div>
  </div>
</template>

<script setup lang="ts">
import { PairingItemFormat } from '@amit/types';
import type { PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { isTextEmpty, parseTooltip, countUnitsInHtml } from '@amit/tiptap';
import { nextTick, onMounted, ref, computed } from 'vue';
const { t } = useI18n();
const props = defineProps({
  format: {
    type: String as PropType<PairingItemFormat>,
    default: PairingItemFormat.TextImage,
  },
  title: {
    type: String,
    default: '',
  },
  rtl: {
    type: Boolean,
    default: true,
  },
  color: {
    type: String,
    default: '#F3F7FC',
  },
});

const maxLength = computed(() => (props.format.includes('image') ? 17 : 95));

const scrollBox = ref();
const hasVerticalScroll = ref(false);

const checkScroll = () => {
  nextTick(() => {
    requestAnimationFrame(() => {
      const el = scrollBox.value as HTMLElement;
      if (!el) return;

      const katexEl = el.querySelector('.rendered-katex');

      if (katexEl) {
        //@ts-ignore
        hasVerticalScroll.value =
          el.scrollHeight > (props.format.includes('image') ? 75 : 100);
      } else {
        hasVerticalScroll.value = false;
      }
    });
  });
};

onMounted(() => {
  nextTick(checkScroll);
});
</script>

<style scoped>
.has-image:has(.rendered-katex) {
  overflow-y: auto;
}
</style>
